export enum ServerEndpoint {
    Authorize = "authorize",
    DeviceAuthorization = "device_authorization",
    Jwks = "jwks",
    Metadata = "metadata",
    Network = "network",
    OpenIDConfig = "open_id_config",
    Registration = "registration",
    Token = "token",
}

const names = {
    [ServerEndpoint.Authorize]: 'GET /oauth2/authorize',
    [ServerEndpoint.DeviceAuthorization]: 'POST /oauth2/device_authorization',
    [ServerEndpoint.Jwks]: 'GET /oauth2/jwks',
    [ServerEndpoint.Metadata]: 'GET /metadata',
    [ServerEndpoint.Network]: 'GET /oauth2/network/*params',
    [ServerEndpoint.OpenIDConfig]: 'GET /oauth2/.well-known/openid-configuration',
    [ServerEndpoint.Registration]: 'POST /oauth2/registration',
    [ServerEndpoint.Token]: 'POST /oauth2/token',
}

export const ServerEndpointGetName = (endpoint: ServerEndpoint): string => {
    if (names[endpoint]) return names[endpoint];
    return endpoint;
};